import { createAction } from '@reduxjs/toolkit';
export const STOP_CALL_RECORDING = 'STOP_CALL_RECORDING';
export const stopCallRecordingAction = createAction(STOP_CALL_RECORDING);